import { useEffect, useRef } from "react";

export const useResizeObserver = (ref, callback) => {
  const resizeObserver = getObserver();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    let unsubscribe = false;
    function _callback(entry, observer) {
      if (!unsubscribe) {
        callbackRef.current(entry, observer);
      }
    }

    resizeObserver.subscribe(element, _callback);

    return () => {
      unsubscribe = true;
      resizeObserver.unsubscribe(element, _callback);
    };
    // eslint-disable-next-line
  }, [ref.current, resizeObserver, callbackRef]);
};

let _resizeObserver;
const getObserver = () => (
  !_resizeObserver ? (_resizeObserver = createObserver()) : _resizeObserver
);
const createObserver = () => {
  const callbackMap = new Map();
  const observer = new ResizeObserver((entries,obs) => {
    const done = new Set();
    for (let i = 0; i < entries.length; i++) {
      if (done.has(entries[i].target)) continue;
      done.add(entries[i].target);
      const cbList = callbackMap.get(entries[i].target);
      cbList && cbList.forEach(cb => cb(entries[i], obs));
    }
  });

  const subscribe = (target, callback) => {
    observer.observe(target);
    const cbList = callbackMap.get(target) ?? [];
    cbList.push(callback);
    callbackMap.set(target, cbList);
  };

  const unsubscribe = (target, callback) => {
    const cbList = callbackMap.get(target) ?? [];
    if (cbList.length === 1) {
      //最後の1件の場合、監視を停止
      observer.unobserve(target);
      callbackMap.delete(target);
      return;
    }
    const deleteIdx = cbList.indexOf(callback);
    if (deleteIdx !== -1) {
      cbList.splice(deleteIdx, 1);
      callbackMap.set(target, cbList);
    }
  };

  return {
    observer,
    subscribe,
    unsubscribe
  }
};